/**
 * Created by frank.law on 12/5/17.
 */
export default class LoginUtils {
    // Regex taken from emailregex.com
    static emailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    static tenant = 'tenant';

    static checkUsernameValidity(username, challenge) {
        // If the login flow comes from user, username must have a value and must be a valid email
        // If the login flow comes from tenant, username must have a value but don't need to be a valid email address
        return (username !== undefined && username.length > 0) && (challenge === this.tenant || username.match(this.emailRegex));
    }

    static isValidEmail(email) {
        return email !== undefined && email.length > 0 && email.match(this.emailRegex);
    }

    static checkPasswordsMatch(password1, password2) {
        return (password1 === password2);
    }

    static checkAuthCodeValidity(authCode) {
        return (authCode !== undefined && (authCode.length === 6 || authCode.length === 8) && authCode.match('^[0-9]*$'));
    }

    static isEmpty(o) {
        return typeof o === 'undefined' || o === null;
    }
}
